import { NgModule } from "@angular/core";
import { ResetPasswordFormModule } from "../reset-password-page/components/reset-password-form/reset-password-form.module";
import { ResetPasswordDialogComponent } from "./reset-password-dialog.component";

@NgModule({
  declarations: [ResetPasswordDialogComponent],
  imports: [ResetPasswordFormModule],
})
export class ResetPasswordDialogModule {}
